import { useTypeVehicles } from "./hooks/useTypeVehicles";
import { useSurveys } from "./hooks/useSurveys";
import { useSurveyCommand } from "./hooks/useSurveyCommand";
import Button from "../../common/components/Button";
import Textfield from "../../common/components/Textfiled";
import Select from "../../common/components/Select";
import IconButton from "../../common/components/IconButton";
import LoadingSpinner from "./components/LoadingSpinner";
import Pagination from "../../common/components/Pagination";
import SurveyColumn from "./components/SuveryColumn";
import { BsSearch } from "react-icons/bs";
import PDFInspeccionVehiculos from "../../common/components/PDFInspeccionVehiculos";
import { Row } from "react-bootstrap";
import Swal from "sweetalert2";

const ALERT_OPTIONS = [
  { label: "⚫ Todos", value: "" },
  { label: "🟢 Aprobado", value: "aprobado" },
  { label: "🟡 En proceso", value: "en proceso" },
  { label: "🔴 Advertencia", value: "advertencia" },
];

function VehicleInspection() {
  const { typeVehicles } = useTypeVehicles();
  const {
    surveys,
    loading,
    filters,
    errorFilters,
    page: currentPage,
    onPage: onChangePage,
    totalPages,
    handleChangeFilters,
    loadSurveys,
    exportToExcel,
    exportSimpleExcel,
    loadingActions,
    refresh,
  } = useSurveys();
  const {
    approveSurvey,
    updateSurvey,
    loading: loadingActions2,
  } = useSurveyCommand(refresh);

  const actions = {
    preOperationalChecklist: () => {
      window.location.href = "/lista-preguntas-preoperacional";
    },
    exportToExcel: () => {
      exportToExcel();
    },
    exportSimpleExcel: () => {
      exportSimpleExcel();
    },
  };

  const handleChangePage = (newPage) => {
    onChangePage(newPage);
    loadSurveys({ page: newPage });
  };

  const handleApproveRejectSurvey = async (survey) => {
    const action = await Swal.fire({
      title: "¿Está seguro de que desea aprobar esta encuesta?",
      text: "Recuerde revisar la información antes de tomar la decisión.",
      icon: "warning",
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "✔ Aprobar",
      denyButtonText: "✖ Rechazar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#28a745",
      denyButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      reverseButtons: false,
      focusConfirm: true,
    });

    const surveyAux = {
      Consecutivo: survey.consecutivo_encuesta,
      Cedula: survey.cedula,
      Celular: survey.celular,
      Estado: survey.estado,
      Fecha: survey.fecha,
      Kilometraje: survey.kilometraje,
      Nombre: survey.nombre,
      Placa: survey.placa,
      ...survey.respuestas
        .filter((res) => res.id_pregunta > 0)
        .reduce((acc, res) => {
          acc[res.pregunta] = res.traduccion_respuesta || res.respuesta || null;
          return acc;
        }, {}),
    };

    if (action.isConfirmed) {
      approveSurvey(surveyAux).then(() => loadSurveys());
    }

    if (action.isDenied) {
      // Handle rejection
    }
  };

  const handleUpdateSurvey = async (survey) => {
    const confirmed = await Swal.fire({
      title: "¿Está seguro de que desea editar esta encuesta?",
      text: "Recuerde revisar la información antes de tomar la decisión.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "✔ Editar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#007bff",
      cancelButtonColor: "#6c757d",
      reverseButtons: false,
      focusConfirm: true,
    });

    if (confirmed.isConfirmed) {
      updateSurvey(survey.respuestas).then(() => loadSurveys());
    }
  };

  const midPoint = Math.ceil(surveys.length / 2);
  const leftSurveys = surveys.slice(0, midPoint);
  const rightSurveys = surveys.slice(midPoint);

  return (
    <main className="container-fluid p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Gestión de velocidad</h1>
      </header>

      <section className="shadow w-100 d-flex flex-column mb-4">
        <h2 className="h4 m-0 fw-semibold text-center mb-3">
          Filtros de búsqueda
        </h2>
        <div className="d-flex gap-3 justify-content-center align-items-center flex-wrap">
          <div>
            <div className="d-flex gap-3">
              <Textfield
                label="Fecha inicio"
                type="date"
                name="initialDate"
                value={filters.initialDate}
                onChange={({ value }) =>
                  handleChangeFilters("initialDate", value)
                }
                error={errorFilters.initialDate}
              />
              <Textfield
                label="Fecha fin"
                type="date"
                name="finalDate"
                value={filters.finalDate}
                onChange={({ value }) =>
                  handleChangeFilters("finalDate", value)
                }
                error={errorFilters.finalDate}
              />
            </div>
            {errorFilters.date && (
              <small className="text-danger">{errorFilters.date}</small>
            )}
          </div>

          <Select
            label="Grupo de preguntas"
            name="groupQuestion"
            value={filters.groupQuestion}
            onChange={({ value }) =>
              handleChangeFilters("groupQuestion", value)
            }
            options={typeVehicles.map((vehicle) => ({
              label: vehicle.nombre,
              value: vehicle.id,
            }))}
            error={errorFilters.groupQuestion}
          />
          <Select
            label="Advertencia"
            name="warning"
            noDefaultOption={true}
            value={filters.warning}
            onChange={({ value }) => handleChangeFilters("warning", value)}
            options={ALERT_OPTIONS}
            error={errorFilters.warning}
          />
          <Textfield
            label="Placa"
            placeholder={"Placa del vehículo"}
            name="placa"
            value={filters.placa}
            onChange={({ value }) => handleChangeFilters("placa", value)}
            error={errorFilters.placa}
          />
          <IconButton
            tooltipText="Consultar encuestas"
            onClick={() => loadSurveys()}
          >
            <BsSearch size={24} />
          </IconButton>
        </div>
      </section>

      <section className="shadow w-100 d-flex flex-column mb-4">
        <h2 className="h4 m-0 fw-semibold text-center mb-3">
          Acciones disponibles
        </h2>
        <div className="d-flex gap-3 justify-content-center flex-wrap flex-md-nowrap align-items-center mb-3">
          <Button onClick={actions.preOperationalChecklist}>
            Lista Chequeo preoperacional
          </Button>
          <div className="w-100">
            <PDFInspeccionVehiculos encuestas={surveys} />
          </div>
          <Button
            color="#28a745"
            onClick={actions.exportToExcel}
            loading={loadingActions}
          >
            Exportar archivo plano
          </Button>
          <Button
            color="#28a745"
            onClick={actions.exportSimpleExcel}
            loading={loadingActions}
          >
            Exportar SISI VIGIA
          </Button>
        </div>
      </section>

      <section className="d-flex flex-column shadow p-3 mb-4">
        {loading && <LoadingSpinner />}

        <Row xs={1} md={2} className="g-0">
          <SurveyColumn
            surveys={leftSurveys}
            handleApproveRejectSurvey={handleApproveRejectSurvey}
            handleUpdateSurvey={handleUpdateSurvey}
            loadingActions={loadingActions2}
          />
          <SurveyColumn
            surveys={rightSurveys}
            handleApproveRejectSurvey={handleApproveRejectSurvey}
            handleUpdateSurvey={handleUpdateSurvey}
            loadingActions={loadingActions2}
          />
        </Row>

        <Pagination
          onChangePage={handleChangePage}
          page={currentPage}
          totalPages={totalPages}
        />
      </section>
    </main>
  );
}

export default VehicleInspection;
